import {Stack, CircularProgress} from "@mui/material";

function GradientCircularProgress({show = true, absolute = true}: {show?: boolean, absolute?: true}) {
    return show ? (
        <Stack direction="row" sx={{ justifyContent: "center", padding: "1em", top: "50%", left: "50%", zIndex: 1000, position: absolute ? 'absolute' : 'fixed' }}>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#fa8e28" />
                        <stop offset="100%" stopColor="#321e00" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
        </Stack>
    ) : undefined;
}

export default GradientCircularProgress
